// Coordinator08:53:24Z: provisional local wording; CTO/Will confirmation before publication.
export const NO_DEPARTMENT_COMPARISON = "No department comparison is available for this selection. Department figures appear when at least two groups can be shown safely.";
